import { IconProps } from "interfaces/icons";

const SettingsIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 20;
	if (size) {
		height = size;
	}

	return (
		<svg
			width={height}
			height={height}
			viewBox="0 0 20 21"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g
				id="Rev-4"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<g
					id="Nova-Enterprise---Home-Page-v2"
					transform="translate(-1002.000000, -40.000000)"
					fill={color}
				>
					<g id="Top-Nav-Bar" transform="translate(75.000000, 0.000000)">
						<g id="Search" transform="translate(329.000000, 25.000000)">
							<path
								d="M608,22.3662 C606.479,22.3662 605.241,23.6042 605.241,25.1252 C605.241,26.6452 606.479,27.8842 608,27.8842 C609.521,27.8842 610.759,26.6452 610.759,25.1252 C610.759,23.6042 609.521,22.3662 608,22.3662 L608,22.3662 Z M608,29.6562 C605.501,29.6562 603.469,27.6242 603.469,25.1252 C603.469,22.6262 605.501,20.5942 608,20.5942 C610.499,20.5942 612.531,22.6262 612.531,25.1252 C612.531,27.6242 610.499,29.6562 608,29.6562 L608,29.6562 Z M607.384,33.3522 L608.616,33.3522 L608.929,31.4832 L609.498,31.3462 C610.147,31.1892 610.768,30.9322 611.339,30.5832 L611.839,30.2762 L613.382,31.3792 L614.254,30.5072 L613.151,28.9622 L613.458,28.4622 C613.808,27.8912 614.064,27.2742 614.222,26.6232 L614.358,26.0542 L616.228,25.7412 L616.228,24.5092 L614.358,24.1962 L614.222,23.6272 C614.064,22.9772 613.808,22.3572 613.458,21.7862 L613.151,21.2862 L614.254,19.7432 L613.382,18.8712 L611.839,19.9732 L611.339,19.6672 C610.768,19.3172 610.147,19.0602 609.498,18.9032 L608.929,18.7662 L608.616,16.8972 L607.384,16.8972 L607.071,18.7662 L606.502,18.9032 C605.853,19.0602 605.232,19.3172 604.661,19.6672 L604.161,19.9732 L602.618,18.8712 L601.746,19.7432 L602.849,21.2862 L602.542,21.7862 C602.192,22.3572 601.936,22.9772 601.778,23.6272 L601.642,24.1962 L599.772,24.5092 L599.772,25.7412 L601.642,26.0542 L601.778,26.6232 C601.936,27.2742 602.192,27.8912 602.542,28.4622 L602.849,28.9622 L601.746,30.5072 L602.618,31.3792 L604.161,30.2762 L604.661,30.5832 C605.232,30.9322 605.853,31.1892 606.502,31.3462 L607.071,31.4832 L607.384,33.3522 Z M610.117,35.1252 L605.883,35.1252 L605.513,32.9092 C605.08,32.7702 604.659,32.5952 604.255,32.3872 L602.427,33.6932 L599.432,30.6982 L600.738,28.8692 C600.529,28.4662 600.354,28.0452 600.216,27.6122 L598,27.2422 L598,23.0082 L600.216,22.6372 C600.354,22.2052 600.529,21.7842 600.738,21.3802 L599.432,19.5522 L602.427,16.5562 L604.255,17.8632 C604.659,17.6542 605.08,17.4792 605.513,17.3412 L605.883,15.1252 L610.117,15.1252 L610.487,17.3412 C610.92,17.4792 611.341,17.6542 611.745,17.8632 L613.573,16.5562 L616.568,19.5522 L615.262,21.3802 C615.471,21.7842 615.646,22.2052 615.784,22.6372 L618,23.0082 L618,27.2422 L615.784,27.6122 C615.646,28.0452 615.471,28.4662 615.262,28.8692 L616.568,30.6982 L613.573,33.6932 L611.745,32.3872 C611.341,32.5952 610.92,32.7702 610.487,32.9092 L610.117,35.1252 Z"
								id="settings"
							/>
						</g>
					</g>
				</g>
			</g>
		</svg>
	);
};

export default SettingsIcon;
